import { render, staticRenderFns } from "./elementCourseNameEditor.vue?vue&type=template&id=5faebe86&scoped=true&"
import script from "./elementCourseNameEditor.vue?vue&type=script&lang=js&"
export * from "./elementCourseNameEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faebe86",
  null
  
)

export default component.exports